import { useCallback, useMemo } from 'react'

import type { UseFormTrigger } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import type { TPropostaSchemaInput } from '@/features/proposta/brasil/domain/schemas'
import { showToast } from '@/infra/sonner'

export const steps = [
  'InformacoesIniciaisStep',
  'CadastroCompradoresStep',
  'DetalhesDaPropostaStep',
  'ResumoStep',
] as const
export type TSteps = (typeof steps)[number]
export type StepValidationStrategy = {
  [K in TSteps]: () => Promise<boolean>
}

export function useStepValidationStrategy(trigger: UseFormTrigger<TPropostaSchemaInput>) {
  const { t } = useTranslation('proposta')

  const stepValidationStrategy: StepValidationStrategy = useMemo(
    () => ({
      InformacoesIniciaisStep: () => trigger('informacoesIniciais'),
      CadastroCompradoresStep: () => trigger('cadastroCompradores'),
      DetalhesDaPropostaStep: async () => {
        const isValid = await trigger('detalhesDaProposta')
        if (!isValid) {
          showToast({
            message: t('detalhes_proposta.toasts.erro_obrigatorios'),
            variant: 'error',
            closeButton: true,
          })
        }
        return isValid
      },
      ResumoStep: () => trigger(),
    }),
    [trigger, t],
  )

  const validateStep = useCallback((step: TSteps) => stepValidationStrategy[step](), [stepValidationStrategy])

  return { validateStep }
}
